import { Grid } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { WidgetConfig } from '../../components/elements/Draggable';
import ChartCompletionRate from './ChartCompletionRate';
import TrainingBudgetRealization from './TrainingBudgetRealization';
import LearningEngagement from './LearningEngagement';
import SatisfactoryReport from './SatisfactoryReport';
import KnowledgeImprovement from './KnowledgeImprovement';
import ChartTraining from './ChartTraining';
import { useMutation } from '@tanstack/react-query';
import { getDataStructure } from '../../services/dashboardExecutive';
import { showNotification } from '../../utilities/mantineNotification';
import useLocalStorage from '../../hooks/useUserData';
import FailedIllustration from '../../components/fragments/IllustrationState/FailedIllustration';
import { ERROR_STATE } from '../../constants/defaultValues/errorState';

interface WidgetListProps {
  itemsList: WidgetConfig[];
  startDate: string;
  endDate: string;
  categoryId: string;
}

const WidgetList: React.FC<WidgetListProps> = ({
  itemsList,
  categoryId,
  startDate,
  endDate
}) => {
  const [userData, setUserData] = useLocalStorage('persist:root', null);
  const auth = JSON.parse(userData?.auth);
  const profile = auth?.userData;
  const binusianId = profile?.binusianId;

  const [structureData, setStructureData] = useState<any>(null);
  useEffect(() => {
    console.log(itemsList);
    getStructureData.mutate();
  }, [binusianId]);

  const getStructureData = useMutation({
    mutationFn: () => getDataStructure(binusianId),
    onSuccess: (data) => {
      setStructureData(data?.data?.data[0]);
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: error.toString()
      });
    }
  });

  return (
    <Grid grow mt={24}>
      {itemsList.map((item, index) => {
        if (structureData) {
          if (item.typeDataChart === 'TCTP' && item.display) {
            return (
              <ChartTraining
                bandName={structureData.bandName}
                buCode={structureData.buCode}
                buName={structureData.buName}
                subBuCode={structureData.subBuCode}
                subBuName={structureData.subBuName}
                deptCode={structureData.deptCode}
                deptName={structureData.deptName}
                sectionCode={structureData.sectionCode}
                sectionName={structureData.sectionName}
                title={item.title}
                key={index}
                startDate={startDate}
                endDate={endDate}
              />
            );
          }
          if (item.typeDataChart === 'CRP' && item.display) {
            return (
              <ChartCompletionRate
                title={item.title}
                key={index}
                startDate={startDate}
                endDate={endDate}
                bandName={structureData.bandName}
                buCode={structureData.buCode}
                buName={structureData.buName}
                subBuCode={structureData.subBuCode}
                subBuName={structureData.subBuName}
                deptCode={structureData.deptCode}
                deptName={structureData.deptName}
                sectionCode={structureData.sectionCode}
                sectionName={structureData.sectionName}
              />
            );
          }
          if (item.typeDataChart === 'KI' && item.display) {
            return (
              <KnowledgeImprovement
                key={index}
                title={item.title}
                startDate={startDate}
                endDate={endDate}
                bandName={structureData.bandName}
                buCode={structureData.buCode}
                buName={structureData.buName}
                subBuCode={structureData.subBuCode}
                subBuName={structureData.subBuName}
                deptCode={structureData.deptCode}
                deptName={structureData.deptName}
                sectionCode={structureData.sectionCode}
                sectionName={structureData.sectionName}
              />
            );
          }
          if (item.typeDataChart === 'TBR' && item.display) {
            return (
              <TrainingBudgetRealization
                key={index}
                title={item.title}
                startDate={startDate}
                endDate={endDate}
                bandName={structureData.bandName}
                buCode={structureData.buCode}
                buName={structureData.buName}
                subBuCode={structureData.subBuCode}
                subBuName={structureData.subBuName}
                deptCode={structureData.deptCode}
                deptName={structureData.deptName}
                sectionCode={structureData.sectionCode}
                sectionName={structureData.sectionName}
              />
            );
          }
          if (item.typeDataChart === 'SR' && item.display) {
            return (
              <SatisfactoryReport
                key={index}
                title={item.title}
                startDate={startDate}
                endDate={endDate}
                bandName={structureData.bandName}
                buCode={structureData.buCode}
                buName={structureData.buName}
                subBuCode={structureData.subBuCode}
                subBuName={structureData.subBuName}
                deptCode={structureData.deptCode}
                deptName={structureData.deptName}
                sectionCode={structureData.sectionCode}
                sectionName={structureData.sectionName}
              />
            );
          }
          if (item.typeDataChart === 'LE' && item.display) {
            return (
              <LearningEngagement
                key={index}
                title={item.title}
                startDate={startDate}
                endDate={endDate}
                bandName={structureData.bandName}
                buCode={structureData.buCode}
                buName={structureData.buName}
                subBuCode={structureData.subBuCode}
                subBuName={structureData.subBuName}
                deptCode={structureData.deptCode}
                deptName={structureData.deptName}
                sectionCode={structureData.sectionCode}
                sectionName={structureData.sectionName}
              />
            );
          }
        }

        return (
          // <FailedIllustration
          //   title={ERROR_STATE.error[0]}
          //   description="Failed to get profile detail"
          // />
          <></>
        );
      })}
    </Grid>
  );
};

export default WidgetList;
